
const config = {
  // eslint-disable-next-line no-undef
  baseURL: process.env.NODE_ENV ==='development'?'http://localhost:5002':'https://api-backoffice.app.taxi.rio',
  urlFoto: 'https://storage.googleapis.com/taxiriofotos/drivers'
};
export default config;
